<template>
  <div>
    <shared-view-consultation></shared-view-consultation>
  </div>
</template>

<script>
import { EventBus } from '@/../eventbus'
import SharedViewConsultation from '@/views/Shared/Consultations/Consultations/View'

export default {
  name: 'Window.Consultation.View',
  components: {
    SharedViewConsultation
  },
  data () {
    return {
      memberId: 0,
      consultationId: 0
    }
  },
  mounted () {
    this.memberId = this.$route.params.id
    this.consultationId = this.$route.params.consultationId
    this.loadViewConsultation()
  },
  methods: {
    async loadViewConsultation () {
      EventBus.$emit('initLoadViewConsultation', { id: this.memberId, consultationId: this.consultationId })
    }
  }
}
</script>

<style scoped>

</style>
